<template>
  <PersonnelInspection/>
</template>
<script>
import PersonnelInspection from 'place/personnelverify/personnelInspection.vue'
export default {
    components:{
      PersonnelInspection
    }
}
</script>